import React, { useState } from "react";
import { useRouter } from "next/router";
import { BaseWine } from "../../../context/wineContext/reducer";
import WineVintages from "../Wines/elements/WineVintages";

interface BaseWineResultProps {
  baseWine: BaseWine;
  year?: string;
};

const BaseWineResult = ({
  baseWine,
  year
}: BaseWineResultProps) => {
  const router = useRouter();
  const [hover, setHover] = useState(false);
  const handleClick = () => {
    router.push("/wines/" + baseWine.slug)
  }

  const handleVintageChange = (e) => {
    router.push("/wines/" + baseWine.slug + "/" + e)
  }

  if(!baseWine.producer) return null;

  return (
    <div
      className="transition-all pb-1 py-2 space-y-2 xl:space-y-none xl:space-x-4 border-b last:border-0 w-full flex flex-col xl:flex-row xl:items-center xl:justify-center"
      onMouseEnter={() => {
        setHover(true);
      }}
      onMouseLeave={() => {
        setHover(false);
      }}
    >
      <div className="w-full xl:w-1/2">
        <button
          onClick={(e) => {
            e.preventDefault();
            handleClick();
          }}
          className="transition-all font-bold text-xl cursor-pointer"
        >
          <h3 className={hover ? 'text-red' : ''}>
            {baseWine.wine_name}
          </h3>
        </button>

        <p 
          className="font-light text-sm cursor-pointer hover:text-red"
        >
          <button 
            onClick={(_) => handleClick()}
            onKeyDown={(e) => {if (e.key === "Enter") handleClick()}}
            tabIndex={0}
            aria-label={`View reviews from ${baseWine?.producer.producer_name}`}
          >
            Producer: <b>{ baseWine?.producer.producer_name }</b>
          </button>
          
        </p>
      </div>
      <div className="w-full xl:w-2/3">
        <WineVintages 
          className="xl:-mt-3"
          vintages={baseWine.wine_vintages}
          onChange={handleVintageChange}
          hrefBase={`/wines/${baseWine.slug}`}
          viewAllLink={`/wines/${baseWine.slug}`}
          year={year}
        />
      </div>
    </div>
  )
}

export default BaseWineResult;
